// extracted by mini-css-extract-plugin
export default {"wrapper":"AllExhibitionsPage_wrapper__Ct+BF","exhibitiosList":"AllExhibitionsPage_exhibitiosList__uNO2r"};